import { createMemoryHistory, createRouter, createWebHistory, type Router } from 'vue-router'

export const createVueRouter = (): Router => createRouter({
  history: import.meta.env.SSR ? createMemoryHistory('/') : createWebHistory('/'),
  scrollBehavior: (to, from, savedPosition) => {
    window.scrollTo(0, 0)
  },
  routes: [
    {
      path: '/',
      name: 'home.index',
      component: () => import('@/pages/home/Index.vue'),
    },
    {
      path: '/producten/webshop',
      name: 'products.webshop',
      component: () => import('@/pages/products/Webshop.vue'),
    },
    {
      path: '/producten/website',
      name: 'products.page',
      component: () => import('@/pages/products/Page.vue'),
    },
    {
      path: '/producten/pos',
      name: 'products.pos',
      component: () => import('@/pages/products/Pos.vue'),
    },
    {
      path: '/producten/qr',
      name: 'products.qr',
      component: () => import('@/pages/products/Qr.vue'),
    },
    {
      path: '/producten/manager',
      name: 'products.manager',
      component: () => import('@/pages/products/Manager.vue'),
    },
    {
      path: '/prijzen',
      name: 'pricing.index',
      component: () => import('@/pages/pricing/Index.vue'),
    },
    {
      path: '/cases/lunchroom',
      name: 'cases.lunchroom',
      component: () => import('@/pages/cases/Lunchroom.vue'),
    },
    {
      path: '/cases/sushi',
      name: 'cases.sushi',
      component: () => import('@/pages/cases/Sushi.vue'),
    },
    {
      path: '/cases/cafetaria',
      name: 'cases.cafetaria',
      component: () => import('@/pages/cases/Cafetaria.vue'),
    },
    {
      path: '/cases/italian',
      name: 'cases.italian',
      component: () => import('@/pages/cases/Italian.vue'),
    },
    {
      path: '/cases/grillroom',
      name: 'cases.grillroom',
      component: () => import('@/pages/cases/Grillroom.vue'),
    },

    {
      path: '/downloads',
      name: 'info.downloads',
      component: () => import('@/pages/info/Downloads.vue'),
    },

    {
      path: '/integraties',
      name: 'info.integrations',
      component: () => import('@/pages/info/Integrations.vue'),
    },
    {
      path: '/info/support',
      name: 'info.support',
      component: () => import('@/pages/info/Support.vue'),
    },
    {
      path: '/info/faq',
      name: 'info.faq',
      component: () => import('@/pages/info/Faq.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/pages/errors/404.vue'),
      name: 'not-found',
    },
  ],
})